import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback, useMemo } from 'react';
import { pathwayCalculate } from 'actions/pathwayCalculate';
import { PathwayUrl } from 'data/pathways';

const usePathwayLocationType = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { search } = useLocation();
  const useUpdatedLocations = true;
  const query = useMemo(
    () => PathwayUrl.new(search, useUpdatedLocations),
    [useUpdatedLocations, search],
  );
  const urlLocationType = useMemo(() => query.hydrateLocationType(), [query]);
  const calculate = useCallback(
    (locationType, input) => {
      dispatch(
        pathwayCalculate({
          locationType,
          input,
          locations: [],
        }),
      );
    },
    [dispatch],
  );
  const urlUpdate = useCallback(
    (locationType, input) => {
      navigate({ search: query.withLocationType(locationType).toString() });
      calculate(locationType, input);
    },
    [navigate, query, calculate],
  );
  return [urlLocationType, urlUpdate];
};

export default usePathwayLocationType;
